import { createContext } from 'react';

export interface ConfirmOptions {
    title: string;
    message: string;
    show: boolean;
    confirmText: string;
    cancelText?: string;
    catchOnCancel?: boolean;
}

export const ConfirmContext = createContext<(options: ConfirmOptions) => Promise<void>>(Promise.reject);
